import { useState } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { FormattedMessage, useIntl } from 'react-intl'
import { Box, TextField, FormHelperText } from '@mui/material'
import { Connection } from 'features/connections'
import settings from 'settings'
import QueryTimeoutForm from './QueryTimeoutForm'

const connectionLimits = settings.connectionLimits

interface QueryConcurrencyControlFormProps {
  form: Omit<UseFormReturn, 'handleSubmit' | 'formState'>
  connection?: Connection
}

const maxConcurrentQueriesName = 'maxConcurrentQueries'
const defaultMaxConcurrentQueries = connectionLimits.maxConcurrentQueries.default

function QueryConcurrencyControlForm({ form, connection }: QueryConcurrencyControlFormProps) {
  const intl = useIntl()
  const { register } = form
  const [maxConcurrentQueriesError, setMaxConcurrentQueriesError] = useState<boolean>(false)
  const maxConcurrentQueriesIsNotValidMsg = intl.formatMessage(
    { id: 'connections.create.advanced.queryConcurrencyControl.maxConcurrentQueries.invalidMessage' },
    connectionLimits.maxConcurrentQueries
  )

  const validateMaxConcurrentQueries = (value: string) => {
    const numericValue = Number(value)
    const { min, max } = connectionLimits.maxConcurrentQueries
    const isValid = Number.isInteger(numericValue) && numericValue >= min && numericValue <= max
    setMaxConcurrentQueriesError(!isValid)
    return isValid
  }

  return (
    <>
      <Box display="flex">
        <Box width="100%">
          <TextField
            type="number"
            size="small"
            defaultValue={connection?.maxConcurrentQueries || defaultMaxConcurrentQueries}
            label={
              <FormattedMessage id="connections.create.advanced.queryConcurrencyControl.maxConcurrentQueries.label" />
            }
            placeholder={intl.formatMessage(
              { id: 'connections.create.advanced.queryConcurrencyControl.maxConcurrentQueries.placeHolder' },
              { default: connectionLimits.maxConcurrentQueries.default }
            )}
            helperText={maxConcurrentQueriesError && maxConcurrentQueriesIsNotValidMsg}
            error={maxConcurrentQueriesError}
            {...register(maxConcurrentQueriesName, { required: false, validate: validateMaxConcurrentQueries })}
          />
        </Box>

        <QueryTimeoutForm form={form} connection={connection} />
      </Box>
      <FormHelperText>
        <FormattedMessage id="connections.create.advanced.queryConcurrencyControl.helperText" />
      </FormHelperText>
    </>
  )
}

export default QueryConcurrencyControlForm
